module.exports = __webpack_public_path__ + "static/media/loan-type.56d9bd9e.svg";